'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

require('./Loader.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Loader(_ref) {
  var isVisible = _ref.isVisible;

  return _react2.default.createElement(
    'div',
    { className: (0, _classname2.default)('Loader', { 'is-visible': isVisible }) },
    _react2.default.createElement('div', { className: 'Loader__image' })
  );
}

Loader.propTypes = {
  isVisible: _propTypes2.default.bool
};

Loader.defaultProps = {
  isVisible: false
};

exports.default = Loader;


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/Loader/Loader.js
// module id = 1168
// module chunks = 0